module.exports = __webpack_public_path__ + "static/media/ic_feather_filter.9deed083.svg";